import React, { useState } from 'react';
import WorkplaceWorkersFilter from './WorkplaceWorkersFilter';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import FlatList from '../../../../Base/Components/FlatList';
import WorkplaceWorkersListItem from './WorkplaceWorkersListItem/WorkplaceWorkersListItem';
import { View } from '../../../../../Enums/View.enum';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import { useLazyWorkplaceWorkersListQuery } from '../../../../../graphql/graphql';
import useWorkplaceWorkers from '../../../Hooks/useWorkplaceWorkers';
// @ts-ignore
import styles from './WorkplaceWorkersList.module.scss';
import WorkplaceWorkersToolbar from './WorkplaceWorkersToolbar';
import { useAppContext } from '../../../../../Services/AppContext';

interface Props {
	showAllWorkplaces: boolean;
	rootWorkplace: {
		id?: string;
		name?: string | null;
		address?: string | null;
	};
}

const WRAPPER_ID = 'workplaceWorkersListWrapper';

const WorkplaceWorkersList: React.FC<Props> = ({
	showAllWorkplaces,
	rootWorkplace,
}) => {
	const { workplaceId } = useAppContext();
	const [view, setView] = useState(View.GRID);
	const [getWorkplaceWorkersQuery, { data, isLoading }] =
		useLazyWorkplaceWorkersListQuery();
	const { getWorkplaceWorkers, getNextPage, page, setPage } =
		useWorkplaceWorkers(getWorkplaceWorkersQuery, rootWorkplace.id);

	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getWorkplaceWorkers,
		{
			data: data?.doctors?.data,
			totalPages: data?.doctors?.meta?.totalPages,
			page: data?.doctors?.meta?.page,
		},
		page,
		setPage,
		{
			rootWorkplaceId: rootWorkplace.id,
			workplaceIds: showAllWorkplaces ? undefined : workplaceId,
		},
	);

	return (
		<div className={styles.wrapper}>
			<WorkplaceWorkersFilter
				onFilter={setFilter}
				showWorkplacesFilter={showAllWorkplaces}
			/>
			<WorkplaceWorkersToolbar
				itemsCount={data?.doctors?.meta?.count || 0}
				onViewChange={setView}
				activeView={view}
				reloadData={loadData}
			/>
			<ScrollContainer wrapperId={WRAPPER_ID} className={styles.background}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					itemKey='id'
					className={styles[view]}
					renderItem={item => (
						<WorkplaceWorkersListItem
							item={item}
							onRefresh={loadData}
							view={view}
							showAllWorkplaces={showAllWorkplaces}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default WorkplaceWorkersList;
